var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      class: _vm.containerStyle,
      attrs: { "justify-start": "", "fill-height": "", column: "" }
    },
    [
      _c("v-flex", { attrs: { "align-self-center": "", shrink: "" } }, [
        _c("div", { class: _vm.$style.title }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c(
            "v-layout",
            { attrs: { "justify-center": "" } },
            [_vm._t("default")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/NestedMenu.vue?vue&type=template&id=17ab73b4&
// module id = null
// module chunks = 